import type { SessionDetail } from '../domain/session-detail.model';

export type LoadStatus = 'idle' | 'loading' | 'loaded' | 'failed';

/** The six header actions, each mapped 1:1 to a gateway pipeline operation. */
export type MutationKind = 'pause' | 'resume' | 'retry' | 'cancel' | 'reset' | 'retryErrors';
export type MutationStatus = 'idle' | 'pending' | 'succeeded' | 'failed';

export interface MutationState {
  status: MutationStatus;
  kind: MutationKind | null;
  error: string | null;
}

/**
 * Redux state for the admin Session Detail page. The slice owns the loaded
 * session + the load / action (mutation) lifecycles; ephemeral UI (the open logs
 * panel, the "show older actions" toggle, the client-side target filters) stays
 * local to the page.
 *
 * `loadStarted` keeps the current `session` so the 3s background poll never blanks
 * the page (the page guards on `session`, not on `loadStatus`).
 */
export interface SessionDetailState {
  session: SessionDetail | null;
  loadStatus: LoadStatus;
  mutation: MutationState;
}

export const emptyMutation: MutationState = {
  status: 'idle',
  kind: null,
  error: null,
};

export const initialState: SessionDetailState = {
  session: null,
  loadStatus: 'idle',
  mutation: emptyMutation,
};
